<template>
  <div>
    <div class="header">
      <div class="header-logo">
        <img src="../assets/logo.png" alt="easyRight-logo" />
        <p>easyRight</p>
      </div>
      <nav id="navbar">
        <ul>
          <li><a href="#services">Leistungen</a></li>
          <li><a href="#pricing">Preise</a></li>
          <li><a href="#about">Über uns</a></li>
          <li><a href="#contact">Kontakt</a></li>
          <li id="login"><a href="login">Login</a></li>
        </ul>
      </nav>
    </div>
    <!-- Hero Section -->
    <section id="hero">
      <div class="hero-content">
        <p class="hero-stext">Wir machen Ihre Texte</p>
        <h1 class="hero-title">Rechtssicher</h1>
        <!-- <button type="button">
          <p>Jetzt Starten</p>
        </button>-->
      </div>
    </section>
    <!-- Features Box Section -->
    <section id="features">
      <div class="feature-box">
        <div class="feature-box-part">
          <span class="material-icons icon">shield</span>
          <!-- Shield icon for Rechtssicher -->
          <h3>Rechtssicher</h3>
          <p>Texte, die rechtlich überzeugen.</p>
        </div>
        <div class="feature-box-part">
          <span class="material-icons icon">person</span>
          <!-- Person icon for Individuell -->
          <h3>Individuell</h3>
          <p>Passgenaue Lösungen für Sie.</p>
        </div>
        <div class="feature-box-part" id="no-border-box">
          <span class="material-icons icon">flash_on</span>
          <!-- Lightning bolt icon for Schnell -->
          <h3>Schnell</h3>
          <p>Zuverlässig, ohne Wartezeit.</p>
        </div>
      </div>
    </section>
    <section id="content">
      <PartnerRender />
      <TutorialComp />
      <CustomerReviews />
      <CTA />
      <FooterComp />
    </section>
  </div>
</template>

<script>
import CTA from "@/components/CTA.vue";
import CustomerReviews from "@/components/CustomerReviews.vue";
import FooterComp from "@/components/FooterComp.vue";
import PartnerRender from "@/components/PartnerRender.vue";
import TutorialComp from "@/components/TutorialComp.vue";
export default {
  components: {
    PartnerRender,
    TutorialComp,
    CustomerReviews,
    CTA,
    FooterComp,
  },
};
</script>

<style scoped>
/* Global Reset for Consistent Styling */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#login {
  background-color: transparent;
  padding: 10px;
  border-left: #fff 1px solid;
}

/* Header Styling */
.header {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  margin-top: 10px;
  z-index: 110;
  justify-content: flex-start;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
}

.header-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-logo img {
  width: 90px;
  margin-right: -5px;
}

.header p {
  color: #fff;
  font-size: 2em;
  font-weight: 400;
}

/* Navigation Bar Styles */
#navbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px 50px;
  display: flex;
  justify-content: flex-end;
  background-color: transparent;
  z-index: 10;
}

#navbar ul {
  list-style: none;
  display: flex;
  gap: 20px;
  align-items: center;
}

#navbar ul li {
  display: inline;
}

#navbar ul li a {
  color: white;
  text-decoration: none;
  font-size: 1.3em;
  font-weight: 400;
  transition: color 0.3s ease;
}

#navbar ul li a:hover {
  color: #c4c4c4; /* Highlight color on hover */
}

/* Hero Section Styles */
#hero {
  width: 100%;
  height: 85vh;
  background-image: url("../assets/background-hero-t1.jpg"); /** -t1*/
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: white;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
}

.hero-content {
  text-align: center;
}

.hero-stext {
  font-size: 1.3rem;
}

.hero-title {
  font-size: 2.6rem;
  font-weight: bold;
  transition: transform 0.3s ease, color 0.3s ease;
}

button {
  background-color: #fff;
  color: #000;
  padding: 10px 20px;
  border-radius: 28px;
  border: none;
  line-height: 2;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin-top: 10px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
}

button:hover {
  cursor: pointer;
}

/* Features Box Section Styles */
#features {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: white;
}

.feature-box {
  width: 60%;
  height: 200px;
  padding: 20px;
  background-color: #fff;
  color: #000;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  gap: 10px;
  text-align: center;
}

.feature-box-part {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  border-right: 1px solid #a3a3a3;
  color: #333;
}

#no-border-box {
  border: none;
}

.feature-box h3 {
  font-size: 1.4rem;
  margin-top: 10px;
}

.feature-box p {
  font-size: 1rem;
  margin-top: 10px;
}

/* Icon Styling */
.icon {
  font-size: 50px;
  margin-top: -10px;
  color: #222;
}

/* Content Box Styling */
#content {
  margin-top: 200px;
  text-align: center;
}

.content-box {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.content-box h2 {
  font-size: 2rem;
  margin-bottom: 20px;
}

.content-box p {
  font-size: 1rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  #navbar ul {
    gap: 15px;
  }

  #navbar ul li a {
    font-size: 0.9rem;
  }

  .hero-title {
    font-size: 2.5rem;
  }

  .feature-box {
    width: 80%; /* On smaller screens, make the feature box wider */
  }
}
</style>
